import works from "./json";

export default works;
